import React from 'react'
import styled from '@emotion/styled'
import { Icon } from '@mobi/component-library/Assets/Icon'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'

export const PreviewTipsToggle = ({
  isNewPreviewTipsLayoutActive,
  isTipsVisible,
  setTipsVisible,
}: {
  isNewPreviewTipsLayoutActive: boolean
  isTipsVisible: boolean
  setTipsVisible: React.Dispatch<React.SetStateAction<boolean>>
}) => {
  return (
    <TipsToggleBarStyled>
      <li>
        <button
          type='button'
          className={isTipsVisible ? 'active' : ''}
          data-testid='tips-toggle-button'
          onClick={() => setTipsVisible(prev => !prev)}
        >
          <Icon name='SolidStar01' size='inherit' color={colors.studio[500]} /> Tips
          {isNewPreviewTipsLayoutActive && <BadgeFOOStyled>NEW</BadgeFOOStyled>}
        </button>
      </li>
    </TipsToggleBarStyled>
  )
}

// ======
// Styles
// ======

const TipsToggleBarStyled = styled.ul({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.smx2,
  minHeight: '5rem',
  margin: 0,
  padding: `0 0 0 ${spacing.md}`,
  boxSizing: 'border-box',
  backgroundColor: colors.white,
  borderBottom: `0.05rem solid ${colors.neutral[200]}`,
  listStyle: 'none',

  '> li': {
    display: 'flex',
    alignItems: 'center',
    minHeight: '5rem',
  },

  'li > button': {
    display: 'flex',
    alignItems: 'center',
    gap: spacing.smx2,
    height: '3.2rem',
    padding: `0 ${spacing.sm}`,
    border: `0.1rem solid ${colors.neutral[200]}`,
    borderRadius: radius.lgx2,
    backgroundColor: colors.white,
    fontSize: font.size.md.fontSize,
    lineHeight: font.size.md.lineHeight,
    fontFamily: font.family.primary,
    cursor: 'pointer',
    transition: 'all 0.2s ease',

    '&.active': {
      backgroundColor: colors.studio[500],
      color: colors.white,
      borderColor: colors.studio[500],
      '> span > svg': { color: colors.white },
    },
  },
})

export const BadgeFOOStyled = styled.span({
  backgroundColor: colors.error[400],
  ...font.size['sm'],
  fontWeight: font.weight.semibold,
  borderRadius: radius.lgx3,
  color: colors.neutral['100'],
  padding: `0.2rem ${spacing.smx1}`,
  marginLeft: spacing.smx2,
})
